import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { SLEntityVersion } from './entity';
import { NotifierService } from '../../ui';


@Component({
  templateUrl: './movement-register.component.html',
})
export class SLMovementRegisterComponent implements OnInit {

  entity: SLEntityVersion

  title: string

  showHidden: boolean = true

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private notifier: NotifierService,
  ) { }

  ngOnInit() {

    this.title = this.route.routeConfig.data.title;

    // Get the entity
    this.notifier.startProgress();

    this.route.data.subscribe((data) => {
      this.entity = data.entity;

      this.notifier.endProgress();
    });
  }

  cancel() {
    this.router.navigate(['shares-ledger', 'entities', this.entity.id]);
  }
}
